var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var text1 = {
    text: {
        fontFamily: 'PT Sans, sans-serif',
        fontWeight: 300,
        fontSize: 22,
        color: 'textAccent',
        lineHeight: 1.3
    },
    background: {
        image: {},
        color: null,
        borderRadius: 0
    },
    border: {
        thickness: 0,
        color: null,
        borderStyle: 'solid'
    },
    spacing: {
        padding: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0
        }
    }
};
var text2 = {
    text: {
        fontFamily: 'PT Sans, sans-serif',
        fontWeight: 300,
        fontSize: 18,
        color: 'textAccent',
        lineHeight: 1.3
    },
    background: {
        image: {},
        color: null,
        borderRadius: 0
    },
    border: {
        thickness: 0,
        color: null,
        borderStyle: 'solid'
    },
    spacing: {
        padding: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0
        }
    }
};
/**
* Add new text1 and text2 global theme elements.
*/
export default function themeMigrations(theme) {
    var updatedTheme = __assign({}, theme); // Migrate from version undefined to version 1.
    // Introduction of new text1 and text2 global elements.
    if (!theme.version) {
        updatedTheme.version = 1;
        var newElements = {};
        if (!updatedTheme.global.elements.hasOwnProperty('text1')) {
            newElements.text1 = text1;
        }
        if (!updatedTheme.global.elements.hasOwnProperty('text2')) {
            newElements.text2 = text2;
        }
        updatedTheme.global = __assign(__assign({}, theme.global), { elements: __assign(__assign({}, theme.global.elements), newElements) });
    }
    return updatedTheme;
}
